import * as angular from "angular";

angular
  .module('app')
  .config(themesConfig);

/* @ngInject */
function themesConfig($mdThemingProvider, triThemingProvider, triSkinsProvider) {

  // Register toast themes
  $mdThemingProvider.theme('success-toast');
  $mdThemingProvider.theme('error-toast');
  $mdThemingProvider.theme('info-toast');
  $mdThemingProvider.theme('warning-toast');

  /**************
   *  PALETTES
   *************/

  $mdThemingProvider.definePalette('white-palette', {
    '50': 'FFFFFF',
    '100': 'FFFFFF',
    '200': 'FFFFFF',
    '300': 'FFFFFF',
    '400': 'FFFFFF',
    '500': 'FFFFFF',
    '600': 'FFFFFF',
    '700': 'FFFFFF',
    '800': 'FFFFFF',
    '900': 'FFFFFF',
    'A100': 'FFFFFF', // Dropdown menu background color
    'A200': '424242', // Dropdown menu font color
    'A400': 'cccccc',
    'A700': 'cccccc',
    'contrastDefaultColor': 'dark', // By default, text (contrast) on this palette should be white with 87% opacity
    'contrastDarkColors': ['50', '100', '200', '300', '400', 'A100', 'A200'] //hues which contrast should be 'dark' by default
  });

  $mdThemingProvider.definePalette('primary-palette', {
    '50': 'FFFFFF',

    '100': '424242',
    '200': '7E7E7E',
    '300': 'F0F0F0',

    '400': 'FAFAFA',
    '500': '9E9E9E',

    '600': '616161', // buttons hover
    '700': '616161', // tooltip background color
    '800': '757575', // buttons background

    '900': '212121',

    'A100': 'FFFFFF', // Dropdown menu background color
    'A200': '424242', // Dropdown menu font color

    'A400': '000000',
    'A700': '000000',

    'contrastDefaultColor': 'dark',
    // 'contrastDarkColors': ['50', '100', '200', '300', '400', 'A100'],
    'contrastLightColors': ['200', '600', '700', '800', '900', '800']
  });

  $mdThemingProvider.definePalette('accent-palette', {
    '50': '9DD4F7',

    '100': '6EAAF5',
    '200': '266AFF',
    '300': 'F1F6FD',

    '400': '266AFF', //buttons background
    '500': '6EAAF5',
    '600': '1472DD',
    '700': 'dd1414',
    '800': '2B5AC7',
    '900': '2B5AC7',
    'A100': 'FFFFFF', // Dropdown menu background color
    'A200': 'FFFFFF', // Dropdown menu font color and button colors
    'A400': 'FFFFFF',
    'A700': '0055C6', //button hover
    'contrastDefaultColor': 'light'
  });

  $mdThemingProvider.definePalette('warn-palette', {
    '50': 'FFBBBB',

    '100': 'D52424',
    '200': 'FF6B6D',
    '300': 'FFEBEB',

    '400': 'F9585A',
    '500': 'F9585A',
    '600': 'F9585A',
    '700': 'F9585A',
    '800': 'F9585A',
    '900': 'F9585A',
    'A100': 'FFFFFF', // Dropdown menu background color
    'A200': 'FFFFFF', // Dropdown menu font color
    'A400': 'F9585A',
    'A700': 'F9585A',
    'contrastDefaultColor': 'light'
  });

  /**************
   *  THEMES
   *************/

  triThemingProvider.theme('bringoz-default')
    .primaryPalette('white-palette')
    .accentPalette('white-palette')
    .backgroundPalette('white-palette')
    .warnPalette('white-palette');


  triThemingProvider.theme('bringoz-main')
    .primaryPalette('primary-palette', {
      'default': '200', // use for toolbar background color
      'hue-1': '100', //  use for primary elements with class .md-hue-1
      'hue-2': '200', //  use for primary elements with class .md-hue-2
      'hue-3': '300' //   use for primary elements with class .md-hue-3
    })
    .accentPalette('accent-palette', {
      'default': '200', // use for button colors & Dialog headers
      'hue-1': '100', // use for button colors with class .md-hue-1
      'hue-2': '200', // use for button colors with class .md-hue-2
      'hue-3': '300' // use for button colors with class .md-hue-2
    })
    .warnPalette('warn-palette', {
      'default': '200', // use for warning background elements add class .md-warn
      'hue-1': '100', // use for warning background elements add class .md-warn
      'hue-2': '200', // use for warning background elements add class .md-warn
      'hue-3': '300' // use for warning background elements add class .md-warn
    })
    .backgroundPalette('primary-palette', {
      'default': '50', // use for content colors
      'hue-1': '50', // use for md-card color
      'hue-2': '50', // use for primary elements with class .md-hue-2
      'hue-3': '50' //  use for primary elements with class .md-hue-3
    });

  /**************
   *  SKINS
   *************/

  triSkinsProvider.skin('bringoz-main', 'Bringoz Main')
    .sidebarTheme('bringoz-default')
    .logoTheme('bringoz-default')
    .toolbarTheme('bringoz-default')
    .contentTheme('bringoz-main');

  // OLD Theme
  // triSkinsProvider.skin('bringoz-main', 'Bringoz Main')
  //     .sidebarTheme('dark')
  //     .logoTheme('dark')
  //     .toolbarTheme('white')
  //     .contentTheme('white-grey');


  /**
   *  FOR DEMO PURPOSES ALLOW SKIN TO BE SAVED IN A COOKIE
   *  This overrides any skin set in a call to triSkinsProvider.setSkin if there is a cookie
   *  REMOVE LINE BELOW FOR PRODUCTION SITE
   */
  triSkinsProvider.useSkinCookie(true);

  /**
   *  SET DEFAULT SKIN
   */
  //triSkinsProvider.setSkin('zesty-orange');
  //triSkinsProvider.setSkin('bringoz-light');
  triSkinsProvider.setSkin('bringoz-main');
}
